import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import MDButton from "components/MDButton";
import { FINANCEIRO_ACCENT } from "../../components/financeiro-lancamentos.theme";
import DespesasFixasSection, {
  type DespesasFixasSectionProps,
} from "./DespesasFixasSection";

const DESPESAS_FIXAS_MODAL_MAX_WIDTH = 1280;

export type DespesasFixasModalProps = DespesasFixasSectionProps & {
  open: boolean;
  onClose: () => void;
};

export default function DespesasFixasModal({
  open,
  onClose,
  fornecedores,
  onRefetchFornecedores,
  onTitulosGerados,
}: DespesasFixasModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          overflow: "hidden",
          width: { xs: "100%", sm: "96vw" },
          maxWidth: DESPESAS_FIXAS_MODAL_MAX_WIDTH,
          maxHeight: "92vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          background: `linear-gradient(135deg, rgba(249,96,48,0.08) 0%, transparent 55%)`,
          flexShrink: 0,
        }}
      >
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "rgba(249,96,48,0.12)",
              color: FINANCEIRO_ACCENT,
              flexShrink: 0,
            }}
          >
            <EventRepeatOutlinedIcon />
          </Box>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="h6" fontWeight={800} lineHeight={1.3}>
              Despesas fixas mensais
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
              Cadastre contas que se repetem todo mês (aluguel, energia, internet) e
              gere os títulos a pagar de uma só vez.
            </Typography>
          </Box>
        </Stack>
      </Box>

      <DialogContent
        sx={{
          px: 3,
          py: 2,
          flex: 1,
          overflow: "visible",
          "&.MuiDialogContent-root": { overflowY: "visible" },
        }}
      >
        <DespesasFixasSection
          fornecedores={fornecedores}
          onRefetchFornecedores={onRefetchFornecedores}
          onTitulosGerados={onTitulosGerados}
          enabled={open}
          variant="embedded"
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 1.5,
          borderTop: "1px solid",
          borderColor: "divider",
          bgcolor: "grey.50",
          flexShrink: 0,
        }}
      >
        <MDButton variant="outlined" color="dark" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
